import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

import { STICKY_HEADER_HEIGHT } from '@/core/constants/layout';

import { Section } from '../dcrNavigation/dcrNavigation.types';
import { filteredArr } from '../dcrNavigation/dcrNavigationStore';

import { type ProfileNavigationState } from './profileNavigation.types';

const sortByDomOrder = (sections: Section[]): Section[] => {
	if (typeof document === 'undefined') return sections;
	return [...sections].sort((a, b) => {
		const ea = document.getElementById(a.id);
		const eb = document.getElementById(b.id);
		if (!ea || !eb) return 0;

		const pos = ea.compareDocumentPosition(eb);
		if (pos & Node.DOCUMENT_POSITION_FOLLOWING) return -1;
		if (pos & Node.DOCUMENT_POSITION_PRECEDING) return 1;

		return 0;
	});
};

export const useProfileNavigationStore = create<ProfileNavigationState>()(
	devtools(set => ({
		sections: [],
		stickyHeaderHeight: STICKY_HEADER_HEIGHT,

		addSection: (section: Section) =>
			set(({ sections }) => ({
				sections: sortByDomOrder(filteredArr([...sections, section]))
			})),
		removeSection: (id: Section['id']) =>
			set(({ sections }) => ({
				sections: sections.filter(s => s.id !== id)
			})),
		setStickyHeaderHeight: (stickyHeaderHeight: number) =>
			set({ stickyHeaderHeight })
	}))
);
